<template>
  <BreadCrumb PageTitle="ISPs" />
  <div class="row" v-if="user">
    <div class="col-xxl-12">
      <IspContent />
    </div>
  </div>
</template>

<script setup>
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import IspContent from "../../components/Admin/Isp/IspContent.vue";

import { useAccountStore } from "@/stores";
import { storeToRefs } from "pinia";
const accountStore = useAccountStore();
const { user } = storeToRefs(accountStore);
</script>

